var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:2.835px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Family",
    transform: "translate(-733 -608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_812",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(733 608)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    transform: "translate(266.292 273.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_88",
    d: "M0 0L111.936 0",
    className: "cls-2",
    transform: "translate(489.233 513.459)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    transform: "translate(471.708 385.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    transform: "translate(0 .082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    d: "M489.763 523.3c1.4-7.76 2.681-15 4-22.232 1.6-8.764 3.3-17.511 4.791-26.293.216-1.275-.521-2.711-.817-4.073-1.332.426-2.894.541-3.953 1.331-3.843 2.868-7.486 6-11.265 8.96-3.435 2.687-6.78 2.644-9.191.016-2.361-2.572-2.173-6.036.726-9.2 5.933-6.466 11.973-12.832 17.928-19.278a13.3 13.3 0 0 1 10.235-4.445c10.422.009 20.867-.393 31.255.209 4.031.234 7.932 2.728 12.639 4.47 1.289-1.277 3.538-3.427 5.7-5.662a19.046 19.046 0 0 1 14.362-6.017q14.4.052 28.8 0a19.074 19.074 0 0 1 14.673 6.236c6.373 6.806 12.807 13.555 19.177 20.363 3.477 3.717 3.812 7.734.988 10.544-2.766 2.752-6.478 2.533-10.274-.674-4.19-3.539-8.27-7.213-12.556-10.631-1.253-1-3.044-1.323-4.589-1.956-.409 1.509-1.165 3.016-1.174 4.527-.085 16.319-.053 32.638-.052 48.957v4.868H573.6c-7.927 0-8.142-.011-7.732-7.726a11.482 11.482 0 0 1 2.884-6.692c4.77-5.1 10.014-9.756 15-14.662 3.2-3.146 3.579-6.666 1.229-9.487-2.46-2.954-6.189-3.106-9.859-.245-4.433 3.456-8.719 7.1-13.185 10.515-8.239 6.3-18.384 6.306-26.655.013-4.254-3.237-8.343-6.693-12.543-10-4.238-3.341-7.874-3.417-10.513-.3-2.558 3.018-2 6.426 1.74 10.07 4.91 4.785 9.87 9.519 14.791 14.292 2.241 2.174 3.821 10.271 2.44 13a2.524 2.524 0 0 1-1.857 1.159c-12.993.06-25.989.043-39.577.043zm75.484-44.381a16.679 16.679 0 1 0-17.264 16.115 16.747 16.747 0 0 0 17.264-16.116z",
    className: "cls-2",
    transform: "translate(-471.708 -395.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    d: "M599.5 426.35a20.453 20.453 0 1 1 20.654-20.191A20.545 20.545 0 0 1 599.5 426.35z",
    className: "cls-2",
    transform: "translate(-490.716 -385.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    d: "M542.37 417.206a18.734 18.734 0 1 1-18.8-18.748 18.665 18.665 0 0 1 18.8 18.748z",
    className: "cls-2",
    transform: "translate(-477.581 -387.747)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    d: "M524.293 398c-8.231 15.638-17.245 12.931-17.245 12.931",
    className: "cls-2",
    transform: "translate(-477.961 -387.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    d: "M528.048 400c8.231 15.638 17.245 12.931 17.245 12.931",
    className: "cls-2",
    transform: "translate(-481.676 -387.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    d: "M583.386 397.112s8.324 4.924 14.086-.015 20.661 1.443 20.661 1.443",
    className: "cls-2",
    transform: "translate(-491.468 -387.093)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.6ad52aa19227f25dc8f9f55e91cb342d.svg";
export { ForwardRef as ReactComponent };